// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"a70f7c74","138":"b9a41586"}[chunkId] + ".chunk.css";
};